// StoreHoursUI.tsx
import { LockClock, AddBusiness } from "@mui/icons-material";
import { Button, Paper, Typography } from "@mui/material";
import React, { memo } from "react";

import { Employee } from "0.Mine/3.Interfaces/Employee";
import { BusinessService } from "0.Mine/3.Interfaces/Services";

import AddEmployee from "../Container/AddEmployee";
import { EmployeeCard } from "../Container/CardEmployee";
import { defaultSchedule } from "../Logic/EmployeeDefaults";

export interface StoreHoursUIProps {
  employees: Employee[];
  showAddForm: boolean;
  toggleAddForm: () => void;
  handleAddEmployee: (employeeToAdd: Employee) => Promise<void>;
  handleUpdateEmployee: (updatedEmployee: Employee) => void;
  handleDeleteEmployee: (employeeId: number) => void;
  ALL_AVAILABLE_SERVICES: BusinessService[];
  onFileUpload: (employeeId: number, file: File) => void;
}

export const BusinessEmployeeFormUI: React.FC<StoreHoursUIProps> = ({
  employees,
  showAddForm,
  toggleAddForm,
  handleAddEmployee,
  handleUpdateEmployee,
  handleDeleteEmployee,
  ALL_AVAILABLE_SERVICES,
  onFileUpload,
}) => {
  return (
    <Paper elevation={3} sx={{ mx: "auto", p: 4, borderRadius: 2, boxShadow: "unset" }}>
      {/* Add Employee Button */}
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddBusiness />}
        onClick={toggleAddForm}
        fullWidth
        sx={{ mb: 3, py: 1.5 }}
      >
        {showAddForm ? "Annulla modifica" : "Aggiungi collaboratore"}
      </Button>

      {/* Add Employee Form */}
      <AddEmployee
        ALL_AVAILABLE_SERVICES={ALL_AVAILABLE_SERVICES}
        show={showAddForm}
        onAdd={handleAddEmployee}
        defaultSchedule={defaultSchedule}
        employees={employees}
      />

      {/* Existing Employees */}
      {employees.map((employee, index) => (
        <EmployeeCard
          key={employee.id}
          employee={employee}
          index={index}
          onUpdate={handleUpdateEmployee}
          onDelete={handleDeleteEmployee}
          onFileUpload={onFileUpload}
        />
      ))}
    </Paper>
  );
};

export default memo(BusinessEmployeeFormUI);
